import * as React from 'react';

import { NavigationLinkTypes } from '../../constants/navigation';
import styles from '../infrastructure/index.css';

export interface IInfrastructureProps {
  infrastructureList: string[];
}

export interface IInfrastructureDispatchProps {
  setNavigationLink(): void;
}

export type IInfrastructurePropsValue = IInfrastructureProps & IInfrastructureDispatchProps;

export class Infrastructure extends React.Component<IInfrastructurePropsValue> {
  public componentDidMount() {
    if (this.props.infrastructureList.length) {
      this.props.setNavigationLink();
    }
  }

  public render() {
    const { infrastructureList } = this.props;

    if (!infrastructureList.length) {
      return null;
    }

    return (
      <div className={styles['container']} id={NavigationLinkTypes.Infrastructure}>
        <h2 className={styles['title']}>Инфраструктура</h2>
        <div className={styles['items-container']}>
          {infrastructureList.map(item => (
            <p key={item} className={styles['infrastructure-item']}>
              {item}
            </p>
          ))}
        </div>
      </div>
    );
  }
}
